import Dropdown from 'common/components/dropdown/Dropdown';
import DropdownItem from 'common/components/popover/PopoverItem';
import { FaFileExport } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Reducers } from 'store/types';
import { UserProfile } from 'api/account/models/UserProfile';
import UsersService from 'api/users/UsersService';
import colors from 'styles/export/colors.module.scss';
import styles from './ExportListingButton.module.scss';

interface Props {
    exportRef: React.MutableRefObject<{ exportExcel: () => Promise<void> } | null>;
    /**
     * Opções extra no mesmo menu, para ecrãs que exportam mais do que a listagem
     * (ex.: Empresas, que também exporta os utilizadores). Evita um segundo botão de
     * exportação no cabeçalho.
     */
    extraOptions?: React.ReactNode;
}

const ExportListingButton = ({ exportRef, extraOptions }: Props) => {
    const { t } = useTranslation();
    const userProfile = useSelector<Reducers, UserProfile | null>(state => state.authentication.profile);
    // O gestor da plataforma exporta sempre — não é limitado por policies de empresa.
    const canExportListing = UsersService.isPlatformAdmin(userProfile?.roles)
        || UsersService.hasPolicies(userProfile?.policies || [], ['SETTINGUP_EXPORT_LISTING_WRITE']);

    if (!canExportListing && !extraOptions) return <></>;

    return (
        <div className={styles.wrapper}>
            <Dropdown style={{ right: 0 }} options={
                <>
                    {canExportListing && <DropdownItem onClick={() => exportRef.current?.exportExcel()}>
                        {t('common.export_listing')}
                    </DropdownItem>}
                    {extraOptions}
                </>
            }>
                <div className={styles.exportButton}>
                    <FaFileExport size={20} color={colors.primaryDark} />
                </div>
            </Dropdown>
        </div>
    );
};

export default ExportListingButton;
